var _a;
import { Claim_Status } from 'generated/types';
import { enumValuesFactory } from 'utils/objectHelper';
var enumDescriptionMap = (_a = {},
    _a[Claim_Status.ActionNeeded] = 'Action needed',
    _a[Claim_Status.InProgress] = 'In progress',
    _a[Claim_Status.Pending] = 'Pending',
    _a[Claim_Status.Resolved] = 'Resolved',
    _a);
export var ClaimStatusEnum = {
    name: 'Claim_Status',
    enumValues: enumValuesFactory(enumDescriptionMap)
};
